import React from 'react';
import PropTypes from 'prop-types';
import { useStores } from 'hooks';
import { Container, HotKeyLabel } from './Styles';

const LaneStartButtons = ({
  disableResume,
  handleResumeClick,
  disableReRun,
  handleReRunClick,
}) => {
  const {
    UIStore: {
      getHotKey,
    },
  } = useStores();
  return (
    <Container>
      <button
        type="button"
        disabled={disableReRun}
        className="primary re-run"
        onClick={handleReRunClick}
      >
        Re-Run
        <HotKeyLabel color="black">
          {getHotKey('target', 'handleReRun').label}
        </HotKeyLabel>
      </button>
      <button
        type="button"
        disabled={disableResume}
        className="primary resume"
        onClick={handleResumeClick}
      >
        Resume
        <HotKeyLabel color="black">
          {getHotKey('target', 'handleResume').label}
        </HotKeyLabel>
      </button>
    </Container>
  );
};


LaneStartButtons.propTypes = {
  disableResume: PropTypes.bool.isRequired,
  handleResumeClick: PropTypes.func.isRequired,
  disableReRun: PropTypes.bool.isRequired,
  handleReRunClick: PropTypes.func.isRequired,
};

export default LaneStartButtons;
